// Passport data page — landscape 265×175 content rotated 90° CCW
// Displayed in portrait container (175×265): transform="translate(0,265) rotate(-90)"
export const PassportGizmo = ({ height = 265, width = 175 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 175 265" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g transform="translate(0, 265) rotate(-90)">
                {/* Corner brackets */}
                <path d="M20 1H8C4.09 1 1 4.09 1 8V20" stroke="black" strokeWidth="1.36"/>
                <path d="M20 174H8C4.09 174 1 170.91 1 167V155" stroke="black" strokeWidth="1.36"/>
                <path d="M245 1H257C260.91 1 264 4.09 264 8V20" stroke="black" strokeWidth="1.36"/>
                <path d="M245 174H257C260.91 174 264 170.91 264 167V155" stroke="black" strokeWidth="1.36"/>

                {/* Card background */}
                <rect x="7" y="7" width="251" height="161" rx="7" fill="#E4EAFA"/>

                {/* Country emblem — top centre */}
                <circle cx="133" cy="21" r="7" stroke="#ADC0F7" strokeWidth="2"/>
                <circle cx="133" cy="21" r="3" fill="#ADC0F7"/>

                {/* "PASSPORT" label */}
                <rect x="108" y="32" width="50" height="3.5" rx="1.75" fill="#ADC0F7"/>

                {/* Portrait photo placeholder — left side */}
                <rect x="14" y="42" width="48" height="64" rx="3" fill="#ADC0F7" opacity="0.45"/>
                {/* Person silhouette */}
                <circle cx="38" cy="61" r="9" stroke="#ADC0F7" strokeWidth="2.5"/>
                <path d="M22 106C26 94 50 94 54 106" stroke="#ADC0F7" strokeWidth="2.5" strokeLinecap="round"/>

                {/* Data fields — right of photo */}
                <rect x="72" y="42" width="179" height="5" rx="2.5" fill="#ADC0F7"/>
                <rect x="72" y="53" width="110" height="3.5" rx="1.75" fill="#ADC0F7"/>
                <rect x="192" y="53" width="59" height="3.5" rx="1.75" fill="#ADC0F7"/>
                <rect x="72" y="63" width="179" height="3.5" rx="1.75" fill="#ADC0F7"/>
                <rect x="72" y="73" width="85" height="3.5" rx="1.75" fill="#ADC0F7"/>
                <rect x="167" y="73" width="84" height="3.5" rx="1.75" fill="#ADC0F7"/>
                <rect x="72" y="83" width="130" height="3.5" rx="1.75" fill="#ADC0F7"/>
                <rect x="72" y="93" width="100" height="3.5" rx="1.75" fill="#ADC0F7"/>

                {/* MRZ divider */}
                <rect x="14" y="116" width="237" height="1" rx="0.5" fill="#ADC0F7" opacity="0.5"/>

                {/* MRZ line 1 — 30 character blocks */}
                {Array.from({ length: 30 }).map((_, i) => (
                    <rect key={`mrz1-${i}`} x={14 + i * 8} y="122" width="5.5" height="7" rx="1" fill="#ADC0F7"/>
                ))}
                {/* MRZ line 2 */}
                {Array.from({ length: 30 }).map((_, i) => (
                    <rect key={`mrz2-${i}`} x={14 + i * 8} y="134" width="5.5" height="7" rx="1" fill="#ADC0F7"/>
                ))}
                {/* MRZ line 3 */}
                {Array.from({ length: 30 }).map((_, i) => (
                    <rect key={`mrz3-${i}`} x={14 + i * 8} y="146" width="5.5" height="7" rx="1" fill="#ADC0F7"/>
                ))}
            </g>
        </svg>
    );
};
